// @flow
import * as React from "react";
import styled, { css } from "styled-components";
import Media from "react-media";
import Gettext from "../common/Gettext";
import Orientation, { isLandscape } from "../common/Orientation";
import { IndexLogo, IndexLogoText } from "../../themes/irontrade/IndexLogo";

const ProjectTitle = () => {
  switch (process.env.REACT_APP_DEPLOY_TARGET) {
    case "siamoption":
      return (
        <Title>
          <Siam>Siam</Siam>
          Option
        </Title>
      );
    case "irontrade":
      return (
        <Title isIntlProject={true}>
          <Iron>Iron</Iron>
          Trade
        </Title>
      );
    default:
      return "Binary Options Broker";
  }
};

const Title = styled.span`
  direction: ${props => props.theme.direction};
  font-weight: 500;
  font-size: 60px;
  color: ${({ isIntlProject, theme }) => (isIntlProject ? theme.sightseeingTitle : "#fff")};
  cursor: default;

  @media (max-height: 840px) {
    font-size: 46px;
  }
`;

const Siam = styled.span`
  color: #feac00;
`;

const Iron = styled.span`
  color: ${props => props.theme.sightseeingIron};
`;

const Popup = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  overflow: auto;
`;

const Table = styled.div`
  display: table;
  vertical-align: middle;
  width: 100%;
  height: 100%;
`;

const Cell = styled.div`
  display: table-cell;
  vertical-align: middle;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1000px;
  width: 95%;
  height: 792px;
  margin: 0 auto;
  padding: 50px 75px 44px 75px;
  text-align: center;
  border-radius: 20px;
  background: ${({ theme }) => theme.sightseeingBg};
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);

  @media (max-width: 1000px) {
    max-width: 940px;
    width: 100%;
  }

  @media (max-height: 840px) {
    height: 615px;
    padding-top: 20px;
    padding-bottom: 20px;
  }
`;

const FirstContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const SubTitle = styled.div`
  margin-top: 30px;
  margin-bottom: 85px;
  font-weight: lighter;
  font-size: 40px;
  line-height: 1.2;
  text-align: center;
  color: ${({ isIntlProject, theme }) => (isIntlProject ? theme.sightseeingTitle : "#fff")};
  cursor: default;

  @media (max-height: 840px) {
    margin-bottom: 45px;
    font-size: 32px;
  }
`;

const Later = styled.span`
  font-weight: lighter;
  font-size: ${({ isMobile }) => (isMobile ? "15px" : "18px")};
  color: ${({ theme }) => theme.sightseeingLater};
  margin: 0;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;

  :hover {
    text-decoration: none;
  }
`;

const Button = styled.button`
  ${({ isMobile }) =>
    isMobile
      ? css`
          display: block;
          max-width: 297px;
          width: 90%;
          height: 45px;
          margin: 0 auto;
          font-size: 18px;
          text-align: center;
          text-transform: uppercase;
          color: ${props => props.theme.sightSeeingStartButtonColor};
          background: ${props => props.theme.sightSeeingStartButtonBg};
          border: none;
          border-radius: 25px;

          @media (max-width: 600px) {
            font-size: 16px;
          }

          @media (max-width: 480px) {
            font-size: ${({ theme }) =>
              theme.locale === "ar" ? theme.minFontSize : "14px"};
          }
        `
      : css`
          height: 80px;
          margin: 0;
          padding: 0 50px;
          min-width: 330px;
          text-align: center;
          border: none;
          border-radius: 90px;
          cursor: pointer;
          font-size: 30px;
          color: ${props => props.theme.sightSeeingStartButtonColor};
          text-transform: uppercase;
          background: ${props => props.theme.sightSeeingStartButtonBg};
        `};
`;

const SliderContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  background-color: ${props => props.theme.main};
  z-index: 9999999;
`;

const SliderView = styled.div`
  width: 100%;
  height: 100%;
`;

const Slide = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  height: 100%;
  overflow: hidden;
  -webkit-text-size-adjust: 100%;

  ${props =>
    props.isLandscape &&
    css`
      flex-direction: row;
    `};
`;

const First = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  overflow: auto;
`;

const FirstTitle = styled.div`
  width: 100%;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
  padding: 0 20px;
  font-weight: 500;
  font-size: 28px;
  color: ${({ isIntlProject, theme }) => (isIntlProject ? theme.sightseeingTitle : "#fff")};
  text-align: center;

  @media (min-width: 360px) {
    font-size: 32px;
  }

  ${props =>
    props.last &&
    css`
      font-size: 32px;

      @media (min-width: 600px) {
        font-size: 40px;
      }
    `};
`;

const FirstText = styled.div`
  width: 100%;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
  padding: 0 20px;
  font-size: 20px;
  line-height: 1.2;
  color: ${({ isIntlProject, theme }) => (isIntlProject ? theme.sightseeingTitle : "#fff")};
  text-align: center;

  @media (min-width: 600px) {
    margin-bottom: 40px;
    font-size: 24px;
  }

  ${props =>
    props.isLandscape &&
    css`
      margin-bottom: 30px;
    `};
`;

const LaterContainer = styled.div`
  margin-top: 15px;
  margin-bottom: 30px;
  text-align: center;

  ${props =>
    props.isLandscape &&
    css`
      margin-bottom: 10px;
    `};
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 25px;
  margin-bottom: 15px;

  ${props =>
    props.isLandscape &&
    css`
      margin-left: 20px;
      margin-right: auto;
    `};
`;

const Logo = styled.div`
  width: 30px;
  height: 22px;
  margin-right: 10px;
  color: ${({ theme }) => theme.sightseeingTitle};

  ${props =>
    props.thProject &&
    css`
      width: 35px;
      height: 22px;
      background: url(${props => props.theme.indexLogo}) no-repeat 50% 50%;
      background-size: cover;
    `};
`;

const LogoText = styled.div`
  width: 84px;
  height: 15px;
  color: ${({ theme }) => theme.sightseeingTitle};

  ${props =>
    props.thProject &&
    css`
      width: 80px;
      height: 15px;
      background: url(${props => props.theme.indexLogoText}) no-repeat 50% 50%;
      background-size: cover;
    `};
`;

const FirstSlideComponent = props => {
  return (
    <Media query="(max-width: 959px)">
      {matches =>
        matches ? (
          <Orientation>
            {screen => (
              <SliderContainer ref={props.forwardedRef}>
                <SliderView>
                  <Slide>
                    <First>
                      <LogoContainer isLandscape={isLandscape(screen)}>
                        {process.env.REACT_APP_DEPLOY_TARGET ===
                        "siamoption" ? (
                          <Logo thProject={true} />
                        ) : (
                          <Logo thProject={false}>
                            <IndexLogo
                              fill="currentColor"
                              width={30}
                              height={22}
                            />
                          </Logo>
                        )}

                        {process.env.REACT_APP_DEPLOY_TARGET ===
                        "siamoption" ? (
                          <LogoText thProject={true} />
                        ) : (
                          <LogoText thProject={false}>
                            <IndexLogoText
                              fill="currentColor"
                              width={84}
                              height={15}
                            />
                          </LogoText>
                        )}
                      </LogoContainer>
                      <div>
                        <FirstTitle
                          isIntlProject={
                            process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
                          }
                        >
                          {/*prettier-ignore*/}
                          <Gettext>
                            Discover {process.env.REACT_APP_DEPLOY_TARGET === "siamoption" ? <Gettext>SiamOption</Gettext> : <Gettext>IronTrade</Gettext>}
                          </Gettext>
                        </FirstTitle>
                        <FirstText
                          isLandscape={isLandscape(screen)}
                          isIntlProject={
                            process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
                          }
                        >
                          <Gettext>
                            Meet the new trade platform and learn about basic
                            functions
                          </Gettext>
                        </FirstText>
                        <Button
                          isMobile={matches}
                          onClick={() => {
                            props.next();
                          }}
                        >
                          <Gettext>Get started</Gettext>
                        </Button>
                      </div>
                      <LaterContainer isLandscape={isLandscape(screen)}>
                        <Later onClick={props.onLater} isMobile={matches}>
                          <Gettext>no, i’d like to do it later</Gettext>
                        </Later>
                      </LaterContainer>
                    </First>
                  </Slide>
                </SliderView>
              </SliderContainer>
            )}
          </Orientation>
        ) : (
          <Popup>
            <Table>
              <Cell>
                <Container>
                  <FirstContainer ref={props.forwardedRef}>
                    <Title
                      isIntlProject={
                        process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
                      }
                    >
                      <Gettext>
                        Discover <ProjectTitle />
                      </Gettext>
                    </Title>
                    <SubTitle
                      isIntlProject={
                        process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
                      }
                    >
                      <Gettext>
                        Meet the new trade platform and learn about basic
                        functions
                      </Gettext>
                    </SubTitle>
                    <Button
                      onClick={() => {
                        props.next();
                      }}
                    >
                      <Gettext>Get started</Gettext>
                    </Button>
                    <div style={{ marginTop: 20 }}>
                      <Later onClick={props.onLater}>
                        <Gettext>no, i’d like to do it later</Gettext>
                      </Later>
                    </div>
                  </FirstContainer>
                </Container>
              </Cell>
            </Table>
          </Popup>
        )
      }
    </Media>
  );
};

export const FirstSlide = React.forwardRef((props, ref) => (
  <FirstSlideComponent {...props} forwardedRef={ref} />
));

export default FirstSlide;



// WEBPACK FOOTER //
// ./src/components/Sightseeing/Intro.js